import type {
  HubAlgorithmDefinition,
  HubExampleStreamDependency,
} from '@robovision/hub'
import { JobBaseDependency } from './JobBaseDependency'


export class JobExampleStreamsDependency extends JobBaseDependency {
  public static fromDefinition (
    exampleStreamDependency: HubExampleStreamDependency,
    algorithmDefinition: HubAlgorithmDefinition,
  ) {
    const exampleDef = algorithmDefinition.exampleDefinitions?.find(
      (def) => def.id === exampleStreamDependency.exampleDefinition,
    )

    if (!exampleDef) {
      throw new Error(
        `Invalid schema. Example definition ${exampleStreamDependency.exampleDefinition} not found`,
      )
    }

    return new JobExampleStreamsDependency({
      definitionId: exampleDef.id,
      dependencyId: exampleStreamDependency.id,
      description: exampleStreamDependency.description,
      name: exampleStreamDependency.name,
    })
  }
}
